<div *ngIf="data">
  <i class="material-icons menu_icon" style="transform: rotate(-90deg);">key</i>
  <span class="en prepaid_pin">{{data.v2}}</span>
  <i class="material-icons menu_icon prepaid_pin_reset" (click)="onLoad(true)">lock_reset</i>
  <i class="material-icons menu_icon prepaid_pin_reset">help</i>
  <div>
    <i class="material-icons menu_icon icon_adjust" style="top:5px;" (click)="onLoad()">replay_circle_filled</i>
    <span>{{localService.languageContent.common.expiry_at}}</span>
    <span class="en">&nbsp;:&nbsp;{{data.v1 | localDate : 'longTime'}}</span>
  </div>
</div>

